import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ServicesPreview() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const services = [
    { icon: 'ri-home-4-line', title: t('servicesPreview.s1.title'), desc: t('servicesPreview.s1.desc') },
    { icon: 'ri-building-office-line', title: t('servicesPreview.s2.title'), desc: t('servicesPreview.s2.desc') },
    { icon: 'ri-registered-line', title: t('servicesPreview.s3.title'), desc: t('servicesPreview.s3.desc') },
    { icon: 'ri-scales-3-line', title: t('servicesPreview.s4.title'), desc: t('servicesPreview.s4.desc') },
    { icon: 'ri-passport-line', title: t('servicesPreview.s5.title'), desc: t('servicesPreview.s5.desc') },
    { icon: 'ri-customer-service-2-line', title: t('servicesPreview.s6.title'), desc: t('servicesPreview.s6.desc') },
  ];

  return (
    <section className="py-24" style={{ backgroundColor: '#F8F9FB' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-blue-600 tracking-widest uppercase mb-3 block">{t('servicesPreview.badge')}</span>
          <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
            {t('servicesPreview.title')}
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            {t('servicesPreview.desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {services.map((service) => (
            <div
              key={service.title}
              className="bg-white rounded-2xl p-7 border border-gray-100 hover:border-blue-200 transition-all duration-300 cursor-default group"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-blue-50 rounded-xl mb-5 group-hover:bg-blue-100 transition-colors duration-200">
                <i className={`${service.icon} text-blue-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed mb-4">{service.desc}</p>
              <button
                onClick={() => navigate('/services')}
                className="whitespace-nowrap text-sm text-blue-600 font-medium flex items-center gap-1 cursor-pointer hover:gap-2 transition-all duration-200"
              >
                {t('servicesPreview.seeDetails')} <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => navigate('/services')}
            className="whitespace-nowrap inline-flex items-center gap-2 border border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white font-medium px-8 py-3.5 rounded-full transition-all duration-200 text-sm cursor-pointer"
          >
            {t('servicesPreview.viewAll')} <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
